<template>
    <v-layout
        wrap
        align-start
    >
        <v-flex
            grow
            pt-2
        >
            <v-tabs
                v-model="tab"
                icons-and-text
                background-color="primary"
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-1">
                    Por pedido
                    <v-icon>mdi-point-of-sale</v-icon>
                </v-tab>

                <v-tab href="#tab-2">
                    Por producto
                    <v-icon>mdi-cash</v-icon>
                </v-tab>
                <v-tab href="#tab-3">
                    Referidos
                    <v-icon>mdi-cash</v-icon>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item
                    key="1"
                    value="tab-1"
                >
                    <PedidosPorCliente
                    ></PedidosPorCliente>
                </v-tab-item>
                <v-tab-item
                    key="2"
                    value="tab-2"
                >
                    <ProductosPorCliente
                    ></ProductosPorCliente>
                </v-tab-item>
                <v-tab-item
                        key="3"
                        value="tab-3"
                >
                    <ReferenciadoPorCliente
                    ></ReferenciadoPorCliente>
                </v-tab-item>
            </v-tabs-items>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment';
    import PedidosPorCliente from "@components/reportes/PedidosPorCliente";
    import ProductosPorCliente from "@components/reportes/ProductosPorCliente";
    import ReferenciadoPorCliente from "@components/reportes/ReferenciadoPorCliente";
    //import EventBus from "@/EventBus";

    moment.locale('es');
    export default {
        name: "ReporteClientesPage",
        components: {
            PedidosPorCliente,
            ProductosPorCliente,
            ReferenciadoPorCliente
        },
        data() {
            return {
                loading : false,
                filter_draft: {
                    desde: null,
                    hasta: null,
                    recompensa_aplicada: 0,
                },
                filter: {
                    desde: null,
                    hasta: null,
                    recompensa_aplicada: 0,
                },
                modal_desde: false,
                modal_hasta: false,
                tab : null
            }
        },
        computed: {

        },
        methods: {
            formatUpdateAt(fecha) {
                let fecha_moment = moment(fecha);

                return fecha_moment.fromNow();
            },
            sendFilter(){
                this.filter = Object.assign(this.filter, this.filter_draft)
            }
        }
    }
</script>

<style scoped>

</style>
